import React from 'react';
import Select from 'react-select';
import customStylesSelect from '@styles/react-select';

const SelectOptionModalComp = React.forwardRef(({
    label,
    name,
    options,
    value,
    onChange,
    placeholder,
    hoverMessage,
    isClearable,
    isLoading,
    isDisabled,
    className,
    error,
    ...rest
}, ref) => {

    return (
        <div className="row mb-2 ms-1" title={hoverMessage}>
            <label
                htmlFor={name}
                className="col-12 col-md-4 border rounded col-form-label fw-bold"
                style={{ color: '#495058' }}
            >
                {label}
            </label>
            <div className="col-12 col-md-8 mt-2 mt-md-0">
                <Select
                    ref={ref}
                    value={value}
                    onChange={onChange}
                    options={options}
                    styles={customStylesSelect}
                    placeholder={placeholder}
                    isClearable={isClearable}
                    isDisabled={isDisabled}
                    isSearchable={false}
                    className={className}
                    {...rest}
                    required
                    isLoading={isLoading}
                    loadingMessage={() => "Carregando..."}
                    noOptionsMessage={() => "Nenhuma opção disponível"}
                />
            </div>
            {error && <p className="text-danger mt-2">{error.message}</p>}
        </div>
    );
});

export default SelectOptionModalComp;